import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import logger from '@adc/logger';
import classnames from 'classnames/bind';
import Tab from '../../../layouts/tab';
import Icon from '../../../elementals/icon';
import MediaPanel, { View as MediaView } from './mediaPanel';
import { Map, Carousel, NotAvailable } from './mediaPanel/views';
import getStreetViewAvailability from '../../../../utils/getStreetViewAvailability';
import Pin from './pin';
import styles from './index.scss';
const cx = classnames.bind(styles);
const Overlay = ({ config, onClose, addressTuple, images, coords, children, activeTabIndex, onTabChange, featureFlags, carouselRef, }) => {
    const panes = [];
    const hasValidCoords = !!coords?.lat && !!coords?.lng;
    const elmId = 'pdp_photo';
    const [streetViewAvailable, setStreetViewAvailable] = useState(false);
    useEffect(() => {
        ;
        (async () => {
            if (coords) {
                try {
                    const available = await getStreetViewAvailability(coords);
                    setStreetViewAvailable(available);
                }
                catch (error) {
                    logger.info('Unhandled error in StreetView availability check:', error);
                    setStreetViewAvailable(false);
                }
            }
        })().catch(error => {
            logger.info('Unhandled error in StreetView availability check:', error);
        });
    }, [coords]);
    panes.push({
        menuItem: {
            disabled: images.length === 0,
            key: 'photos',
            'data-elm-id': 'photos_tab',
            content: (_jsxs(_Fragment, { children: [_jsx(Icon, { name: 'image', iconStyle: 'light', style: { color: 'inherit' }, size: 'large' }), _jsx("span", { children: "Photos" })] })),
        },
        render: () => (_jsx(Tab.Pane, { className: cx('pane'), children: _jsx(Carousel, { images: images, className: cx('carousel'), elmId: elmId, cls: { left: cx('arr-prev'), right: cx('arr-next') }, arrowIconProps: {
                    elmId,
                }, featureFlags: featureFlags, carouselRef: carouselRef }) }, 'photos')),
    });
    panes.push({
        menuItem: {
            key: 'map',
            'data-elm-id': 'map_tab',
            content: (_jsxs(_Fragment, { children: [_jsx(Icon, { name: 'map-marked', iconStyle: 'light', style: { color: 'inherit' }, size: 'large' }), _jsx("span", { children: "Map View" })] })),
        },
        render: () => (_jsx(Tab.Pane, { className: cx('pane'), children: hasValidCoords ? (_jsx(Map, { ...coords, className: cx('map-view'), elmId: 'property_gallery_panel_map_view', apiKey: config.GOOGLE_MAP_CLIENT_ID, apiChannel: config.GOOGLE_MAP_CHANNEL, children: _jsx(Pin, { ...coords }) })) : (_jsx(NotAvailable, { text: 'Map View Not Available' })) }, 'map')),
    });
    if (streetViewAvailable) {
        panes.push({
            menuItem: {
                key: 'street-view',
                'data-elm-id': 'street_tab',
                content: (_jsxs(_Fragment, { children: [_jsx(Icon, { name: 'street-view', iconStyle: 'light', style: { color: 'inherit' }, size: 'large' }), _jsx("span", { children: "Street View" })] })),
            },
            render: () => (_jsx(Tab.Pane, { className: cx('pane'), children: hasValidCoords ? (_jsx(Map, { ...coords, streetview: true, className: cx('street-view'), elmId: 'property_gallery_panel_street_view', apiKey: config.GOOGLE_MAP_CLIENT_ID, apiChannel: config.GOOGLE_MAP_CHANNEL })) : (_jsx(NotAvailable, { text: 'Street View Not Available' })) }, 'street-view')),
        });
    }
    return (_jsx(MediaPanel, { elmId: 'property_gallery_panel', cls: { close: cx('close') }, className: cx('root'), onClose: onClose, children: _jsxs("div", { className: cx('content'), children: [_jsx("div", { className: cx('address'), "data-elm-id": 'property_gallery_panel_address', children: _jsxs("p", { "data-elm-id": 'property_gallery_panel_address1', children: [addressTuple[0], " ", _jsx("br", {}), addressTuple[1]] }) }), _jsxs(MediaView, { children: [_jsx(Tab, { elmId: 'tab', panes: panes, activeIndex: activeTabIndex, onTabChange: (_e, { activeIndex }) => {
                                onTabChange(activeIndex);
                            }, role: 'secondary', collapsing: false, transparentMode: true }), children] })] }) }));
};
Overlay.propTypes = {
    addressTuple: PropTypes.arrayOf(PropTypes.string).isRequired,
    coords: PropTypes.object.isRequired,
    config: PropTypes.object.isRequired,
    images: PropTypes.arrayOf(PropTypes.string).isRequired,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.element,
    activeTabIndex: PropTypes.number,
    onTabChange: PropTypes.func,
    featureFlags: PropTypes.object,
    carouselRef: PropTypes.object,
};
export default Overlay;
//# sourceMappingURL=index.js.map